// src/modules/app-views/omnichannel/pages/Init/modals/TransferModal/Step1.jsx
// *******************************************************************************
// TRANSFER MODAL - STEP 1
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState, useCallback } from 'react';
import { Alert, Form, Select, Input } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const TransferStep1Content = ({ teamMembers = [], currentUserId }) => {
  // ---------------------------------------------------------------------------
  // STATE
  // ---------------------------------------------------------------------------
  const [selectOpen, setSelectOpen] = useState(false);

  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------

  // ANTD v6 fix: controlled open state ensures dropdown closes on first click
  const handleSelect = useCallback(() => {
    setSelectOpen(false);
  }, []);

  const handleOpenChange = useCallback(visible => {
    setSelectOpen(visible);
  }, []);

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES
  // ---------------------------------------------------------------------------
  const agentOptions = teamMembers
    .filter(member => member.accountId !== currentUserId)
    .map(member => ({
      value: member.accountId,
      label: `${member.name} — ${member.email}`,
    }));

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <>
      <Alert
        title={translateX('transfer_conversation_description')}
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <Form.Item
        name="toAccountId"
        label={translateX('select_agent')}
        rules={[{ required: true, message: () => translateX('required_field') }]}
      >
        <Select
          open={selectOpen}
          onSelect={handleSelect}
          onOpenChange={handleOpenChange}
          options={agentOptions}
          placeholder={translateX('select_agent')}
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
        />
      </Form.Item>

      <Form.Item name="note" label={translateX('note_optional')}>
        <Input.TextArea
          rows={3}
          placeholder={translateX('note_placeholder')}
          maxLength={500}
          showCount
        />
      </Form.Item>
    </>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const transferStep = ({ teamMembers, currentUserId } = {}) => ({
  stepTitle: 'transfer_conversation',
  stepTooltip: 'transfer_conversation',
  content: () => (
    <TransferStep1Content
      teamMembers={teamMembers}
      currentUserId={currentUserId}
    />
  ),
  validationFields: ['toAccountId'],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default transferStep;
